import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: '1f7ff8d6-d84e-4247-8f30-fc243337f01a',
    authority: 'https://login.microsoftonline.com/f43877ac-6976-4beb-b238-f92e268fc98c',
    redirectUri: 'https://moba-portal.com',
    postLogoutRedirectUri: 'https://moba-portal.com',
  },

  cache: {
    cacheLocation: 'localStorage', // required for multi-tab
  },
});

export const guardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: {
    scopes: ['User.Read'],
  },
};

export const interceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap: new Map([['https://graph.microsoft.com/v1.0/me', ['User.Read']]]),
};
